import { userConstants } from "../../constant";

export function inbox(state = [], action) {
  switch (action.type) {
    case userConstants.GET_USER_INBOX:
      return {
        inbox: action.inboxes,
      };

    default:
      return state;
  }
}
